import { useState, useEffect } from 'react';
import {
  getSolde3mt, getTransactions3mt, getContributions3mt, getVersementsJoueur,
  addVersements3mt, addEntree3mt, addDepense3mt, deleteTransaction3mt, hasRole, getCurrentUser
} from '../api';

const eur = v => (v || 0).toFixed(2).replace('.', ',') + ' €';

export default function Caisse3mtPage() {
  const [tab, setTab]           = useState('joueurs');
  const [solde, setSolde]       = useState(null);
  const [contribs, setContribs] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [selJoueur, setSelJoueur]   = useState(null);
  const [versements, setVersements] = useState([]);
  const [panel, setPanel]       = useState(null);
  const [form, setForm]         = useState({});
  const [saisie, setSaisie]     = useState({});
  const [dateVers, setDateVers] = useState(new Date().toISOString().split('T')[0]);
  const [libVers, setLibVers]   = useState('');
  const [toast, setToast]       = useState(null);
  const isAdmin = hasRole('tresorier');
  const monJoueurId = getCurrentUser()?.joueur_id;

  useEffect(() => { load(); }, []);
  async function load() {
    const [s, c, t] = await Promise.all([getSolde3mt(), getContributions3mt(), getTransactions3mt()]);
    setSolde(s); setContribs(c); setTransactions(t);
  }
  function showToast(msg, type='success') { setToast({msg,type}); setTimeout(()=>setToast(null),3000); }

  async function openJoueur(id) {
    if (selJoueur === id) return setSelJoueur(null);
    setSelJoueur(id);
    setVersements(await getVersementsJoueur(id));
  }

  async function submitVersements(e) {
    e.preventDefault();
    const list = Object.entries(saisie)
      .filter(([, m]) => parseFloat(m) > 0)
      .map(([joueur_id, montant]) => ({ joueur_id: parseInt(joueur_id), montant }));
    if (!list.length) return showToast('Saisis au moins un montant', 'error');
    try {
      const r = await addVersements3mt({ versements: list, date: dateVers, libelle: libVers });
      showToast(`${r.nb} versement${r.nb>1?'s':''} · ${eur(r.total)}`);
      setSaisie({}); setLibVers(''); setPanel(null); load();
      if (selJoueur) setVersements(await getVersementsJoueur(selJoueur));
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function submitEntree(e) {
    e.preventDefault();
    try { await addEntree3mt(form); showToast('Entrée ajoutée'); setPanel(null); setForm({}); load(); }
    catch(err) { showToast(err.message, 'error'); }
  }

  async function submitDepense(e) {
    e.preventDefault();
    try { await addDepense3mt(form); showToast('Dépense enregistrée'); setPanel(null); setForm({}); load(); }
    catch(err) { showToast(err.message, 'error'); }
  }

  async function supprimer(t) {
    if (!window.confirm(`Supprimer cette opération de ${eur(t.montant)} ?`)) return;
    await deleteTransaction3mt(t.id);
    showToast('Supprimé'); load();
    if (selJoueur) setVersements(await getVersementsJoueur(selJoueur));
  }

  const totalSaisie = Object.values(saisie).reduce((a, m) => a + (parseFloat(m) || 0), 0);
  const nbSaisie    = Object.values(saisie).filter(m => parseFloat(m) > 0).length;
  const totalJoueurs = contribs.reduce((a, c) => a + c.total, 0);

  return (
    <>
      <div className="page-header" style={{ borderBottomColor:'#eab308' }}>
        <div className="eyebrow" style={{ color:'#eab308' }}>Pot commun de l'équipe</div>
        <h1>🍺 3ème Mi-temps</h1>
        {solde && (
          <div className="sub">
            <b style={{ color: solde.solde >= 0 ? '#22c55e' : '#ef4444' }}>{eur(solde.solde)}</b> disponibles
          </div>
        )}
      </div>

      {solde && (
        <div className="kpi-bar">
          <div className="kpi"><div className="val" style={{ color:'#22c55e' }}>{eur(solde.total_entrees)}</div><div className="lbl">Entrées</div></div>
          <div className="kpi"><div className="val" style={{ color:'#ef4444' }}>{eur(solde.total_depenses)}</div><div className="lbl">Dépenses</div></div>
          <div className="kpi"><div className="val" style={{ color:'#eab308' }}>{eur(solde.solde)}</div><div className="lbl">Solde</div></div>
          <div className="kpi"><div className="val">{eur(totalJoueurs)}</div><div className="lbl">Des joueurs</div></div>
        </div>
      )}

      <div className="tabs">
        {[['joueurs','👥 Joueurs'],['historique','📋 Historique']].map(([k,l]) => (
          <button key={k} className={`tab-btn ${tab===k?'active':''}`}
            onClick={()=>{setTab(k);setPanel(null);}}
            style={{ borderBottomColor: tab===k?'#eab308':undefined, color: tab===k?'#eab308':undefined }}>{l}</button>
        ))}
      </div>

      <div className="section">

        {/* ── JOUEURS ── */}
        {tab === 'joueurs' && (
          <>
            {isAdmin && !panel && (
              <div style={{ display:'flex', gap:8, marginBottom:14, flexWrap:'wrap' }}>
                <button className="btn btn-primary" style={{ flex:'1 1 140px', background:'#22c55e' }}
                  onClick={()=>{setSaisie({});setPanel('versements');}}>+ Participations</button>
                <button className="btn btn-secondary" style={{ flex:'1 1 100px' }}
                  onClick={()=>{setForm({});setPanel('entree');}}>+ Entrée</button>
                <button className="btn btn-danger" style={{ flex:'1 1 100px' }}
                  onClick={()=>{setForm({});setPanel('depense');}}>− Dépense</button>
              </div>
            )}

            {/* Saisie des participations */}
            {panel === 'versements' && (
              <div className="card" style={{ marginBottom:14, borderColor:'#22c55e' }}>
                <div style={{ fontSize:12, fontWeight:700, color:'#22c55e', letterSpacing:1,
                  textTransform:'uppercase', marginBottom:12 }}>
                  Saisir les participations
                </div>
                <form onSubmit={submitVersements}>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                    <div className="form-group" style={{ margin:0 }}><label>Date</label>
                      <input type="date" value={dateVers} onChange={e=>setDateVers(e.target.value)} /></div>
                    <div className="form-group" style={{ margin:0 }}><label>Motif</label>
                      <input type="text" value={libVers} onChange={e=>setLibVers(e.target.value)}
                        placeholder="Ex : Match vs Epernon" /></div>
                  </div>

                  <div style={{ marginTop:14, marginBottom:10 }}>
                    <div style={{ fontSize:10, color:'#8b949e', letterSpacing:1, textTransform:'uppercase',
                      fontWeight:600, marginBottom:8 }}>
                      Montant par joueur
                    </div>
                    <div style={{ maxHeight:300, overflowY:'auto' }}>
                      {contribs.map(j => (
                        <div key={j.id} style={{ display:'flex', alignItems:'center', gap:10,
                          padding:'7px 0', borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
                          <span className="num-badge">{j.numero||'—'}</span>
                          <span style={{ flex:1, fontSize:13, minWidth:0 }}>{j.prenom} {j.nom}</span>
                          <div style={{ display:'flex', alignItems:'center', gap:5, flexShrink:0 }}>
                            <input type="number" step="0.01" min="0.01" inputMode="decimal" inputMode="decimal"
                              value={saisie[j.id] || ''}
                              onChange={e=>setSaisie({...saisie, [j.id]: e.target.value})}
                              placeholder="0"
                              style={{ width:72, background:'#0d1117', border:'1px solid rgba(255,255,255,0.1)',
                                borderRadius:7, padding:'7px 9px', color:'#e6edf3', fontSize:14,
                                textAlign:'right', outline:'none' }} />
                            <span style={{ color:'#8b949e', fontSize:13 }}>€</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {nbSaisie > 0 && (
                    <div style={{ background:'#0d1117', borderRadius:8, padding:'11px 14px',
                      marginBottom:12, textAlign:'center', fontSize:13 }}>
                      Total : <b style={{ color:'#22c55e', fontSize:17 }}>{eur(totalSaisie)}</b>
                      <span style={{ color:'#8b949e', fontSize:11 }}> ({nbSaisie} joueur{nbSaisie>1?'s':''})</span>
                    </div>
                  )}

                  <div style={{ display:'flex', gap:10 }}>
                    <button type="submit" className="btn btn-primary" style={{ background:'#22c55e' }}>Enregistrer</button>
                    <button type="button" className="btn btn-secondary" onClick={()=>setPanel(null)}>Annuler</button>
                  </div>
                </form>
              </div>
            )}

            {panel === 'entree' && (
              <div className="card" style={{ marginBottom:14 }}>
                <div style={{ fontSize:12, fontWeight:700, color:'#22c55e', letterSpacing:1,
                  textTransform:'uppercase', marginBottom:12 }}>Entrée hors joueur</div>
                <form onSubmit={submitEntree}>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                    <div className="form-group" style={{ margin:0 }}><label>Montant (€)</label>
                      <input type="number" step="0.01" min="0.01" inputMode="decimal" value={form.montant||''}
                        onChange={e=>setForm({...form,montant:parseFloat(e.target.value)})} required /></div>
                    <div className="form-group" style={{ margin:0 }}><label>Date</label>
                      <input type="date" value={form.date||''} onChange={e=>setForm({...form,date:e.target.value})} /></div>
                  </div>
                  <div className="form-group" style={{ marginTop:10 }}><label>Libellé</label>
                    <input type="text" value={form.libelle||''} onChange={e=>setForm({...form,libelle:e.target.value})}
                      placeholder="Ex : Recette buvette" required /></div>
                  <div style={{ display:'flex', gap:10 }}>
                    <button type="submit" className="btn btn-primary">Ajouter</button>
                    <button type="button" className="btn btn-secondary" onClick={()=>setPanel(null)}>Annuler</button>
                  </div>
                </form>
              </div>
            )}

            {panel === 'depense' && (
              <div className="card" style={{ marginBottom:14, borderColor:'#ef4444' }}>
                <div style={{ fontSize:12, fontWeight:700, color:'#ef4444', letterSpacing:1,
                  textTransform:'uppercase', marginBottom:12 }}>Dépense</div>
                <form onSubmit={submitDepense}>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                    <div className="form-group" style={{ margin:0 }}><label>Montant (€)</label>
                      <input type="number" step="0.01" min="0.01" inputMode="decimal" value={form.montant||''}
                        onChange={e=>setForm({...form,montant:parseFloat(e.target.value)})} required /></div>
                    <div className="form-group" style={{ margin:0 }}><label>Date</label>
                      <input type="date" value={form.date||''} onChange={e=>setForm({...form,date:e.target.value})} /></div>
                  </div>
                  <div className="form-group" style={{ marginTop:10 }}><label>Libellé</label>
                    <input type="text" value={form.libelle||''} onChange={e=>setForm({...form,libelle:e.target.value})}
                      placeholder="Ex : Boissons après match" required /></div>
                  {solde && <div style={{ fontSize:11, color:'#8b949e', marginBottom:12 }}>
                    Solde disponible : {eur(solde.solde)}
                  </div>}
                  <div style={{ display:'flex', gap:10 }}>
                    <button type="submit" className="btn btn-danger">Enregistrer</button>
                    <button type="button" className="btn btn-secondary" onClick={()=>setPanel(null)}>Annuler</button>
                  </div>
                </form>
              </div>
            )}

            <div className="section-title">Participations — clique pour le détail</div>
            {contribs.map(j => (
              <div key={j.id}>
                <div className="card card-row" onClick={()=>openJoueur(j.id)}
                  style={{ cursor:'pointer', marginBottom: selJoueur===j.id ? 0 : 8,
                    background: selJoueur===j.id ? 'rgba(234,179,8,0.06)' : undefined,
                    borderColor: j.id === monJoueurId ? 'rgba(59,130,246,0.45)' : undefined }}>
                  <div style={{ display:'flex', alignItems:'center', gap:11 }}>
                    <span className="num-badge" style={{ color:'#eab308' }}>{j.numero||'—'}</span>
                    <div>
                      <div style={{ fontSize:14, fontWeight:700 }}>
                        {j.prenom} {j.nom}
                        {j.id === monJoueurId && (
                          <span style={{ fontSize:9.5, color:'#3b82f6', background:'rgba(59,130,246,0.15)',
                            border:'1px solid rgba(59,130,246,0.35)', borderRadius:5,
                            padding:'2px 6px', marginLeft:7, letterSpacing:0.5 }}>MOI</span>
                        )}
                      </div>
                      <div style={{ fontSize:11, color:'#8b949e', marginTop:2 }}>
                        {j.nb_versements > 0
                          ? `${j.nb_versements} versement${j.nb_versements>1?'s':''}${j.dernier ? ` · dernier le ${j.dernier}` : ''}`
                          : 'Aucun versement'}
                      </div>
                    </div>
                  </div>
                  <div style={{ fontFamily:'Barlow Condensed', fontSize:20, fontWeight:800,
                    color: j.total > 0 ? '#22c55e' : '#8b949e' }}>
                    {eur(j.total)}
                  </div>
                </div>

                {selJoueur === j.id && (
                  <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.06)',
                    borderTop:'none', borderRadius:'0 0 10px 10px', padding:'10px 14px', marginBottom:8 }}>
                    {versements.length === 0
                      ? <div style={{ color:'#8b949e', fontSize:13, padding:'6px 0' }}>Aucun versement</div>
                      : versements.map(v => (
                        <div key={v.id} style={{ display:'flex', justifyContent:'space-between',
                          alignItems:'center', gap:10, padding:'8px 0',
                          borderBottom:'1px solid rgba(255,255,255,0.05)' }}>
                          <div style={{ minWidth:0 }}>
                            <div style={{ fontSize:12.5 }}>{v.libelle}</div>
                            <div style={{ fontSize:10.5, color:'#8b949e', marginTop:1 }}>
                              {v.date}{v.cree_par && ` · par ${v.cree_par}`}
                            </div>
                          </div>
                          <div style={{ display:'flex', alignItems:'center', gap:7, flexShrink:0 }}>
                            <span style={{ fontWeight:700, fontSize:13, color:'#22c55e' }}>+{eur(v.montant)}</span>
                            {isAdmin && (
                              <button onClick={()=>supprimer(v)}
                                style={{ background:'none', border:'1px solid rgba(239,68,68,0.35)', borderRadius:6,
                                  color:'#ef4444', cursor:'pointer', fontSize:11, padding:'4px 7px' }}>🗑</button>
                            )}
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            ))}
          </>
        )}

        {/* ── HISTORIQUE ── */}
        {tab === 'historique' && (
          <>
            {transactions.length === 0 && (
              <div className="card" style={{ textAlign:'center', color:'#8b949e', padding:'26px 16px' }}>
                Aucune opération
              </div>
            )}
            {transactions.map(t => (
              <div className="card card-row" key={t.id} style={{ padding:'12px 14px' }}>
                <div style={{ minWidth:0 }}>
                  <div style={{ fontSize:13.5, fontWeight:600 }}>
                    <span style={{ color: t.type==='entree'?'#22c55e':'#ef4444', marginRight:6 }}>
                      {t.type==='entree'?'▴':'▾'}
                    </span>
                    {t.libelle}
                  </div>
                  <div style={{ fontSize:11, color:'#8b949e', marginTop:2 }}>
                    {t.date}
                    {t.prenom && ` · ${t.prenom} ${t.nom}`}
                    {t.cree_par && ` · par ${t.cree_par}`}
                  </div>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:9, flexShrink:0 }}>
                  <span style={{ fontFamily:'Barlow Condensed', fontSize:18, fontWeight:800,
                    color: t.type==='entree'?'#22c55e':'#ef4444' }}>
                    {t.type==='entree'?'+':'−'}{eur(t.montant)}
                  </span>
                  {isAdmin && (
                    <button onClick={()=>supprimer(t)}
                      style={{ background:'none', border:'none', color:'#8b949e', cursor:'pointer', fontSize:14 }}>🗑️</button>
                  )}
                </div>
              </div>
            ))}
          </>
        )}
      </div>
      {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
    </>
  );
}
